import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import React from 'react';
import { useTranslation } from 'react-i18next';
import i18n from 'i18n';
import { ClaimSettlementNoticeTableDataType } from 'pages/documents/types/documentsTypes';

const columns: ColumnsType<ClaimSettlementNoticeTableDataType> = [
  {
    title: 'common.date',
    dataIndex: 'date',
    key: 'date',
  },
  {
    title: 'common.description',
    dataIndex: 'description',
    key: 'description',
  },
  {
    key: 'url',
    render: (_, data) => (
      <a href={data.url} target="_blank" rel="noreferrer">
        {i18n.t('common.download')}
      </a>
    ),
  },
];

interface ClaimSettlementNoticeTableProp {
  data: ClaimSettlementNoticeTableDataType[];
}

const ClaimSettlementNoticeTable = ({ data }: ClaimSettlementNoticeTableProp) => {
  const { t } = useTranslation();

  return (
    <Table
      columns={columns.map((column) => {
        return {
          ...column,
          title: t(column.title as string),
        };
      })}
      dataSource={data}
      pagination={{ position: ['bottomLeft'] }}
    />
  );
};

export default ClaimSettlementNoticeTable;
